export default __webpack_public_path__ + "static/sim_logo-7201c65408df113305e886819bf751f4.svg";